import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { connect } from 'react-redux';
import { RootState } from '../../../models/RootState';
import { getCurrencyTypeFromToken } from '../../../store';
import { CURRENCY_TYPE_FACTOR } from '../../../constants/CurrencyTypeFactor';
import { CommissionReportRecord } from '../../../models/CommissionReportRecord';

type CommisionProps = {
  setCompetitionDetails: (record: CommissionReportRecord) => void;
  records: CommissionReportRecord[];
};

const CompetitionAggreagtionReport: React.FC<CommisionProps> = (props) => {
  const { setCompetitionDetails, records} = props;
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  return (
    <div className="reports-ctn user-commission-ctn">
      <>
        <div className="content-ctn light-bg">
          <div className="balance-history-tbl-ctn">
            <div className="tbl-ctn">
              <TableContainer className="tbl-paper-ctn" component={Paper}>
                <Table className="tbl-ctn my-wallet-tbl">
                  <TableHead className="tbl-header-section">
                    <TableRow>
                      <TableCell className="th-col">Competition</TableCell>
                      <TableCell align="left" className="th-col ">
                      Commission
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {records.length > 0 ? (
                    <TableBody className="tbl-body">
                      {records.map((row, idx) => (
                        <TableRow key={idx} className="tb-row">
                          <TableCell
                            component="th"
                            scope="row"
                            className="tb-col b-text m-link"
                            onClick={() => setCompetitionDetails(row)}
                          >
                            {row.competitionName}
                          </TableCell>
                          <TableCell className="tb-col" align="left">
                          {(row.commission/cFactor)?.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableCell className="no-data-row">
                      <div>No records available</div>
                    </TableCell>
                  )}
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
    return {
        loggedIn: state.auth.loggedIn,
    };
};

export default connect(mapStateToProps)(CompetitionAggreagtionReport);
